import React from 'react';
import { NoResultsCard } from '@/components/Cards';
import { Trans } from '@lingui/react/macro';
import { BaseDocument, BuyerResidentialUnitDocument } from '@/types';
import DocumentSelectListItem from './DocumentSelectListItem';
import { DocumentSelectionMode, DocumentSelectionValue } from '.';

type ResidentialUnitDocumentListProps = {
    documents: (BaseDocument | BuyerResidentialUnitDocument)[];
    mode: DocumentSelectionMode;
    value: DocumentSelectionValue;
    onSelectionChange(documentOrVersionId: DocumentSelectionValue): void;
};

const DocumentSelectList: React.FC<ResidentialUnitDocumentListProps> = ({ documents, mode, value, onSelectionChange }) => {
    return (
        <>
            {documents.map((doc) => (
                <DocumentSelectListItem
                    key={doc.documentId}
                    document={doc}
                    selectMode={mode}
                    selectedValue={value}
                    onSelectionChange={onSelectionChange}
                />
            ))}

            {documents.length === 0 && (
                <NoResultsCard>
                    <Trans>No documents</Trans>
                </NoResultsCard>
            )}
        </>
    );
};

export default DocumentSelectList;